import './opere.scss';

import PubSub from 'pubsub-js';
import enquire from 'enquire.js';
import { Responsive } from '../utils';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

const COMPONENT_NAME = 'opere';
// const EVENT_KEY = COMPONENT_NAME;
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_GRID: 'opere__grid',
  ELEMENT_GRID_ITEM: 'opere__item',
};

/**
 * version    1.0
 * class      <type> (Opere)
 */
export class Opere {
  constructor($container = $('body')) {
    const self = this;

    this._vars = {
      isDesktop: true,
    };

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.opere = this._els.container.find(`.${BEM.BLOCK}`);
    this._els.opereGrid = this._els.opere.find(`.${BEM.ELEMENT_GRID}`);
    this._els.opereGridItem = this._els.opere.find(`.${BEM.ELEMENT_GRID_ITEM}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.opere.each(function () {
        self._initSingleInstance($(this));
        TextColorCheck._checkBackground($(this));
      });
    });
  }

  // private methods

  _initSingleInstance($instanceEl) {
    const self = this;
    const isGallery = $instanceEl.find('#gallery').length > 0;

    $instanceEl.find(`.${BEM.ELEMENT_GRID}`).each(function () {
      const $item = $(this);

      self._countOpere($item);
      self._initResponsive();

      if ($item.data('show-all') !== true) {
        self._hideOpere($item);
        self._showOpere();
      }

      // check if there's a gallery
      if (isGallery) {
        self._createGallery($item);
      }
    });
  }

  _createGallery($item) {
    const self = this;

    $item.find(`.${BEM.ELEMENT_GRID_ITEM}`).each((index, el) => {
      const target = $(el).data('target');
      const $elToAppend = $(target).find('.carousel-inner');
      const $clonedEl = $(el).clone();
      const imgUrl = self._vars.isDesktop ? $(el).find('source').last().data('srcset') : $(el).find('source').first().data('srcset');

      $clonedEl.removeClass().addClass('carousel-item');

      if (index === 0) {
        $clonedEl.addClass('active');
      }

      $clonedEl.find('.tcl-picture__image').attr('src', imgUrl).removeClass('lazyload')
        .addClass('lazyloaded');

      // create markup and insert additional info before appending
      self._createMarkup($clonedEl);

      $clonedEl.appendTo($elToAppend);
    });
  }

  _createMarkup($item) {
    const dataPopup = $item.data();

    // svuoto le info che arrivano dal clone
    $item.find('.opere__text').empty();

    // sposto l'immagine a destra
    $item.find('.opere__media').insertAfter($item.find('.opere__text'));

    // aggiungo le classi per il posizionamento su ogni clone
    $item.find('.opere__media').addClass('frg-col-xs-12 frg-col-md-4 frg-col-md-offset-1');
    $item.find('.opere__text').addClass('frg-col-xs-12 frg-col-md-3 frg-col-md-offset-2');

    // inserisco le nuove info passate come data-attribute
    Object.keys(dataPopup).forEach((key) => {
      if (key.includes('popup')) {
        $item.find('.opere__text').prepend($(`<span class="${key}">${dataPopup[key]}</span>`));
      }
    });

    // aggiungo i social in fondo alle info
    // $item.find('.opere__text').append($('<div class="opere__social"><p>Share</p><div class="opere__social__icons"><div/></div>'));

    /* inserisco i social
    Object.keys(dataPopup).forEach((key) => {
      if (key.includes('social')) {
        const socialName = key.replace('social', '').toLowerCase();
        const classSocial = key.replace('social', 'social-').toLowerCase();
        const linkSocial = $(`<a href='${dataPopup[key]}${window.location.href}' class='social-link ${classSocial}' target='_blank'></a>`);
        const svgSocial = $(`<svg role="img" class="svg-icon svg-icon--${classSocial}" title="${socialName}"><use xlink:href="#sprite-${classSocial}"></use></svg>`);

        // click listener to social
        linkSocial.on('click', () => {
          window.location.href = dataPopup[key];
        });

        linkSocial.append(svgSocial);
        $item.find('.opere__social__icons').prepend(linkSocial);
      }
    });
    */
  }

  _checkIfDesktop() {
    const breakpoint = Responsive.getCurrentBreakpointName();
    return breakpoint === 'md' || breakpoint === 'lg';
  }

  _initResponsive() {
    const self = this;

    function handleResolutionChange() {
      self._vars.isDesktop = self._checkIfDesktop();
    }

    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, handleResolutionChange);
    enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, handleResolutionChange);

    handleResolutionChange();
  }

  _hideOpere($item) {
    const self = this;
    const showMoreBtn = self._els.opere.find('.opere__load-more');
    const initialCounter = 9;

    $item.find(`.${BEM.ELEMENT_GRID_ITEM}`).each((index, el) => {
      if (index >= initialCounter) {
        $(el).addClass('opere__item--hide');
        showMoreBtn.show();
      }
    });
  }

  _checkShowAll() {
    const self = this;
    const showMoreBtn = self._els.opere.find('.opere__load-more');

    if (self._els.opere.find('.opere__item--hide').length === 0) {
      showMoreBtn.hide();
    }
  }

  _showOpere() {
    /*
    const self = this;
    const showMoreBtn = self._els.opere.find('.opere__load-more');
    let interval = 9;

    showMoreBtn.on('click', () => {
      $item.find(`.${BEM.ELEMENT_GRID_ITEM}`).each((index, el) => {
        if ($(el).hasClass('opere__item--hide') && interval > 0) {
          $(el).removeClass('opere__item--hide');
          interval -= 1;
          self._checkShowAll();
        }
      });
    });
    */

    const self = this;
    const showMoreBtn = self._els.opere.find('.opere__load-more');
    const interval = 9;

    showMoreBtn.on('click', () => {
      const opereToShow = self._els.opere.find('.opere__item--hide');

      for (let i = 0; i < interval; i += 1) {
        $(opereToShow[i]).removeClass('opere__item--hide');
      }
      self._checkShowAll();
    });
  }

  _countOpere($item) {
    const interval = 3;
    let initialCounter = 1;

    $item.find(`.${BEM.ELEMENT_GRID_ITEM}`).each((index, el) => {
      if (index === initialCounter) {
        initialCounter += interval;
        $(el).addClass('move-up');
      }
    });
  }
}
